import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class Group extends ModelBase {
  public static readonly type = 'Group';
  public readonly type = Group.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('name')
  public name: string;

  @autoserializeAs('can_register_introducees')
  public canRegisterIntroducees = true;

  @autoserializeAs('token')
  public token: string;
}
